import { defineAsyncComponent } from 'vue';

const FlagIconProvider = defineAsyncComponent(() => import('./FlagIconProvider.vue'));

export default FlagIconProvider;
